import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { loginPost } from '../api/MemberAPI';
import { getCookie, setCookie, removeCookie } from '../util/cookieUtil';
import { COOKIE_NAME } from '../Config';

const initState = {
  id: '',
};

export const loginPostAsync = createAsyncThunk('loginPostAsync', (param) => {
  return loginPost(param);
});

const loadMemberCookie = () => {
  //쿠키에서 로그인 정보 로딩

  const memberInfo = getCookie(COOKIE_NAME);
  // console.log('쿠키에서 로그인 정보 로딩', memberInfo);
  //닉네임 처리
  if (memberInfo && memberInfo.name) {
    memberInfo.name = decodeURIComponent(memberInfo.name);
  }

  return memberInfo;
};

const loginSlice = createSlice({
  name: 'LoginSlice',
  initialState: loadMemberCookie() || initState, //쿠키가 없다면 초깃값사용
  reducers: {
    login: (state, action) => {
      // console.log('login.....');
      //{email, pw로 구성 }
      const data = action.payload;

      //새로운 상태
      return { id: data.id };
    },
    logout: (state, action) => {
      // console.log('logout....');
      removeCookie(COOKIE_NAME);
      return { ...initState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginPostAsync.fulfilled, (state, action) => {
        // console.log('fulfilled');

        const payload = action.payload;

        //닉네임 한글 처리
        if (payload.name) {
          payload.name = encodeURIComponent(payload.name);
        }

        //정상적인 로그인시에만 저장
        if (!payload.error) {
          setCookie(COOKIE_NAME, JSON.stringify(payload), 1); //1일
        }

        return payload;
      })

      .addCase(loginPostAsync.pending, (state, action) => {
        // console.log('pending');
      })
      .addCase(loginPostAsync.rejected, (state, action) => {
        // console.log('rejected');
      });
  },
});

export const { login, logout } = loginSlice.actions;

export default loginSlice.reducer;
